import { format } from "date-fns";
import { MinusCircle, PlusCircle } from "lucide-react-native";
import React, { memo } from "react";

import { Button } from "@/components/atoms/Button";
import { Stack } from "@/components/atoms/Stack";
import { Pressable } from "@/components/atoms/Pressable";
import { Text } from "@/components/atoms/Text";

import { ReportsPlayerMatchFragment } from "@/generated/graphql";

/**
 *
 */
interface Props {
  item: ReportsPlayerMatchFragment;
  playerId: string;
  onSelect: () => void;
  selectedMatchIds: string[];
}

/**
 * Displays a selectable match item for report generation.
 * Shows match details and toggle button to add/remove from selection.
 * @param root0 - The component props
 * @param root0.item - Match data including opponent name, date, and match ID
 * @param root0.onSelect - Callback invoked when user taps to select/deselect this match
 * @param root0.selectedMatchIds - Array of currently selected match IDs to show selection state
 */
const MatchItemView = ({ item, onSelect, selectedMatchIds }: Props) => (
  <Stack className="p-3">
    {/* <Link asChild href={`/players/${playerId}/matches/${item.matchId}/intake`}> */}
    <Pressable onPress={onSelect}>
      <Stack
        direction="horizontal"
        className="w-full items-center justify-between gap-3"
      >
        <Text variant="unstyled" className="flex-wrap">
          {item.oppositionName} on {format(item?.matchDate || "", "dd/MM/yyyy")}
        </Text>
        <Button
          variant="link"
          accessibilityLabel={
            selectedMatchIds.includes(item.matchId)
              ? "Deselect match"
              : "Select match"
          }
          onPress={onSelect}
          icon={
            selectedMatchIds.includes(item.matchId) ? MinusCircle : PlusCircle
          }
        />
      </Stack>
    </Pressable>
    {/* </Link> */}
  </Stack>
);

MatchItemView.displayName = "MatchItemView";

export default memo(MatchItemView);
